// Este objeto permite ver el bus en directo
export class LiveBus {
    private id: string;
    private color: string;
    private lat: number;
    private lon: number;
    private active: boolean;

    constructor( id: string, color: string, lat: number, lon: number, active: boolean) {
        this.id = id;
        this.color = color;
        this.lat = lat;
        this.lon = lon;
        this.active = active;
    }

    public setId (id: string) { this.id = id; }
    public getId () { return this.id; }
    
    public setColor (color: string) { this.color = color; }
    public getColor () { return this.color; }
    
    public setLat (lat: number) { this.lat = lat; }
    public getLat () { return this.lat; }
    
    public setLon (lon: number) { this.lon = lon; }
    public getLon () { return this.lon; }
    
    public setActive (active: boolean) { this.active = active; }
    public getActive () { return this.active; }
    
    public searchForId (idSearched: string) {
        if (idSearched == this.id) {
            return true;
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/DTOs/LiveBus.component.ts